import { useState, useRef } from 'react';
import { Box, IconButton, Typography } from '@mui/material';

import { usePdf } from '@mikecousins/react-pdf';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import RemoveRedEyeOutlinedIcon from '@mui/icons-material/RemoveRedEyeOutlined';
function PdfRender(props) {

    let file_url = props.fileurl;


    const [page, setPage] = useState(1);
    const canvasRef = useRef(null);


    const { pdfDocument } = usePdf({ file: file_url, page, canvasRef });

    const downloadLink = (fileurl) => {
        window.open(fileurl);
    }

    return (
        <Box>
            {!pdfDocument && <Typography>Loading...</Typography>}
            {Boolean(pdfDocument && pdfDocument.numPages) && (
                <Box>
                    <IconButton disabled={page === 1} onClick={() => setPage(page - 1)}><KeyboardArrowLeftIcon fontSize='small' /> </IconButton>
                    <IconButton disabled={page === pdfDocument.numPages} onClick={() => setPage(page + 1)}><KeyboardArrowRightIcon fontSize='small' /> </IconButton>
                    <IconButton onClick={() => downloadLink(file_url)}><RemoveRedEyeOutlinedIcon fontSize='small' /> </IconButton>
                </Box>
            )}
            <Box sx={{ width: props.width, height: props.height, overflow: 'auto' }}>
                <canvas ref={canvasRef} style={{ width: (props.canvaswidth) ? props.canvaswidth : 250, height: (props.canvasheight) ? props.canvasheight : 500 }} />
            </Box>
        </Box>
    )
}

export default PdfRender